import styled from 'styled-components';
import doneBg from '../../assets/images/done_bg.png';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	padding-top: 315px;
	background-image: url(${doneBg});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-color: rgba(17, 19, 20, 0.98);

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	& > ${TextLabel} {
		font-size: 16px;
		color: #ffffff;
		margin-top: 17px;
	}
`;

const StyledButton = styled.button`
	height: 40px;
	margin-top: 36px;
	padding: 0 20px;
	background-color: #2d70da;
	border-radius: 10px;
	border: none;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	transition:
		color 0.3s ease,
		background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledCrossButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	margin-top: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

export { StyledContainer, StyledButton, StyledCrossButton };
